import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const UserManagementIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      className="w-6 h-6"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        d="M29.728,20.432l-5.113-1.278a1,1,0,0,1-.739-.775l-.383-1.926A6,6,0,0,0,27,11V8.252A6.166,6.166,0,0,0,21.185,2,5.99,5.99,0,0,0,15.94,4.787,8.409,8.409,0,0,1,18,10.256a8.472,8.472,0,0,0,1.168,4.914A3.009,3.009,0,0,1,18.1,19.377l.274.078A5.021,5.021,0,0,1,22,24.263V28a2.966,2.966,0,0,1-.184,1H31a1,1,0,0,0,1-1V23.342A3,3,0,0,0,29.728,20.432Z"
        fill={color}
        data-color="color-2"
      />
      <path
        d="M17.824,21.378,13.51,20.146a1,1,0,0,1-.675-.65l-.342-1.043a9.907,9.907,0,0,0,4.593-.8,1.009,1.009,0,0,0,.384-1.425A10.467,10.467,0,0,1,16,10.262a6.185,6.185,0,0,0-5.762-6.257A6,6,0,0,0,4,10a10.739,10.739,0,0,1-1.472,6.23,1.008,1.008,0,0,0,.386,1.422,9.907,9.907,0,0,0,4.593.8L7.165,19.5a1,1,0,0,1-.675.65L2.176,21.378A3,3,0,0,0,0,24.263V28a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V24.263A3,3,0,0,0,17.824,21.378Z"
        fill={color}
      />
    </svg>
  );
};
